/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Instruction_1Inputs */

const en_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy the Machine ID from above`)
};

const fr_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiez l'ID de Machine ci-dessus`)
};

const de_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopieren Sie die Maschinen-ID von oben.`)
};

const it_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia l'ID macchina dall'alto`)
};

const ru_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопируйте идентификатор машины, указанный выше.`)
};

const es_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar el ID de la máquina de arriba`)
};

const zh_cn2_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从上方复制机器 ID`)
};

const ja_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上記のマシンIDをコピーします`)
};

const hi_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऊपर से मशीन आईडी कॉपी करें`)
};

const pt_pt2_login_offline_instruction_1 = /** @type {(inputs: Login_Offline_Instruction_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copie o ID da máquina acima.`)
};

/**
* | output |
* | --- |
* | "Copy the Machine ID from above" |
*
* @param {Login_Offline_Instruction_1Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_instruction_1 = /** @type {((inputs?: Login_Offline_Instruction_1Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Instruction_1Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_instruction_1(inputs)
	if (locale === "de") return de_login_offline_instruction_1(inputs)
	if (locale === "it") return it_login_offline_instruction_1(inputs)
	if (locale === "ru") return ru_login_offline_instruction_1(inputs)
	if (locale === "es") return es_login_offline_instruction_1(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_instruction_1(inputs)
	if (locale === "ja") return ja_login_offline_instruction_1(inputs)
	if (locale === "hi") return hi_login_offline_instruction_1(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_instruction_1(inputs)
	return en_login_offline_instruction_1(inputs)
});